import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { Nullable } from "primereact/ts-helpers";
import { Toast } from "primereact/toast";
import { DataTable, DataTableSelectionMultipleChangeEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { InputNumberChangeEvent } from "primereact/inputnumber";
import { Image } from "primereact/image";
import NoDataCreated from "../../../Components/NoDataCreated";
import ErrorPage from "../../../Components/ErrorPage";
import { goToTop } from "../../../Components/goToTop";
import { baseURL } from "../../../Api/ApiConstant";
import { formatDate, parseStringToDate } from "../../../Utils/getDate";
import NumberInput from "../../../Components/NumberInput";
import TextInput from "../../../Components/TextInput";
import FileInput from "../../../Components/FileInput";
import DatePicker from "../../../Components/DatePicker";
import DocumentViewModal from "../../../Components/DocumentViewModal";
import PageLoader from "../../../Components/PageLoader";
import { getAppCurrencyType } from "../../../Utils/Common";
import { ClientAccountProjectType } from "../../../Controllers/Types/HeyTraderTypes/ClientAccountTypes/ClientAccountProjectType";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { getAllClientProjectList, getAllCompanyList } from "../../../Controllers/Thunks/HeyTraderThunks";
import { ClientAccountType, ClientAccountCompany } from "../../../Controllers/Types/HeyTraderTypes/ClientAccountTypes/ClientAccountType";

import {
  checkFileOthers,
  checkNumberForAmount,
  checkText,
} from "../../../Utils/Validator";
import {
  createClientAccount,
  deleteClientAccount,
  shareProjectClientAccount,
  updateClientAccount,
  updateSettlementStatus,
  createCompany,
  updateCompany,
  assignCompany,
  moveClientAccount
} from "../../../Api/HeyTraderService/ClientAccountService";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import { InputSwitch } from "primereact/inputswitch";
import { Message } from "primereact/message";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Dropdown as DropdownType } from 'primereact/dropdown';
import { mapShareContactType, ShareContactType } from "../../../Controllers/Types/Share/ShareContactType";
import ShareModal from "../../../Components/ShareModal";
import { ShareContactTypes } from "../../../Controllers/Types/HeyTraderTypes/ShareContactTypes";
import { getLoginUserRoleName, UserRoleName } from "../../../Utils/LoginUserRoleName";

const ClientAccount: React.FC = () => {
  const today = new Date();
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useRef<Toast>(null);
  const currencySymbol = getAppCurrencyType();

  const loadingPage = useAppSelector((state) => state?.clientAccount?.loader);
  const error = useAppSelector((state) => state?.clientAccount?.errorDisplay);

  const dropdownRef = useRef<DropdownType>(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [dataState, setDataState] = useState<"Add" | "Edit">("Add");

  const [clientAccountDetails, setClientAccountDetails] = useState<ClientAccountProjectType | null>(null);

  // CHANGE 1
  const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | ''>('');



  const [owanProject, setOwanProject] = useState<boolean>(false);

  const [clientAccountData, setClientAccountData] = useState<ClientAccountType[]>([]);
  const [clientAccountDataByType, setClientAccountDataByType] = useState<ClientAccountType[]>([]);
  const [filteredClientAccountData, setFilteredClientAccountData] = useState<ClientAccountType[]>([]);
  const [selectedClientAccount, setSelectedClientAccount] = useState<ClientAccountType | null>(null);
  const [showClientAccountModal, setShowClientAccountModal] = useState<boolean>(false);
  const [clientAccountSubtotal, setClientAccountSubtotal] = useState<number>(0);
  const [clientAccountSearchKey, setClientAccountSearchKey] = useState<string>("");
  const [documentFileUrl, setDocumentFileUrl] = useState<string>("");
  const [showDocViewModal, setShowDocViewModal] = useState<boolean>(false);

  /* Contact share */
  const [activeContactTab, setActiveContactTab] = useState<"All" | "Employee" | "Professional" | "Client">("All");
  const [clientAccountContactsData, setClientAccountContactsData] = useState<ShareContactTypes[]>([]);
  // const [filteredContactsData, setFilteredContactsData] = useState<ShareContactTypes[]>([]);

  const [showContactShareModal, setShowContactShareModal] = useState<boolean>(false);
  const [clientAccountShareData, setClientAccountShareData] = useState<ShareContactType[]>([]);

  const [addOptions, setAddOptions] = useState<number>(0);

  /* Form fields */
  const [accountDate, setAccountDate] = useState<Nullable<Date>>(today);
  const [cashStatus, setCashStatus] = useState<"In" | "Out" | null>(null);
  const [accountTitle, setAccountTitle] = useState<string>("");
  const [accountAmount, setAccountAmount] = useState<number | null>(null);
  const [accountFile, setAccountFile] = useState<File | null>(null);
  const [accountFileName, setAccountFileName] = useState<string>("");

  /* Form errors */
  const [accountDateError, setAccountDateError] = useState<string>("");
  const [cashStatusError, setCashStatusError] = useState<string>("");
  const [accountTitleError, setAccountTitleError] = useState<string>("");
  const [accountAmountError, setAccountAmountError] = useState<string>("");
  const [accountFileError, setAccountFileError] = useState<string>("");

  const [accountState, setAccountState] = useState<'Order' | 'Cash' | 'Credit'>("Order");
  const [accountAddState, setAccountAddState] = useState<'Cash' | 'Credit'>("Cash");
  const [accountType, setAccountType] = useState<'My account' | 'Company account'>("My account");
  const [creditAccountState, setCreditAccountState] = useState<'All' | 'Settled' | 'Unsettled'>("All");
  const [clientCompanyError, setclientCompanyError] = useState<string>("");

  /* For company data */
  const [showCompanyModal, setShowCompanyModal] = useState<boolean>(false);
  const [companyUpdateHasChanges, setCompanyUpdateHasChanges] = useState<boolean>(false);
  const [showCompanyViewModal, setShowCompanyViewModal] = useState<boolean>(false);
  const [companyData, setCompanyData] = useState<ClientAccountCompany[]>([]);
  const [selectedCompany, setSelectedCompany] = useState<ClientAccountCompany | null>(null);
  const [companyName, setCompanyName] = useState<string>("");
  const [accountName, setAccountName] = useState<string>("");
  const [sortCode, setSortCode] = useState<string>("");
  const [accountNumber, setAccountNumber] = useState<string>("");

  const [accountForList, setAccountForList] = useState<ClientAccountCompany[]>([]);
  const [selectedAccountFor, setSelectedAccountFor] = useState<ClientAccountCompany | null>(null);

  /* Errors */
  const [companyNameError, setCompanyNameError] = useState<string>("");
  const [accountNameError, setAccountNameError] = useState<string>("");
  const [sortCodeError, setSortCodeError] = useState<string>("");
  const [accountNumberError, setAccountNumberError] = useState<string>("");


  /* For company */
  const companyListRef = useRef<HTMLDivElement>(null);
  const [clientCompanyList, setClientCompanyList] = useState<ClientAccountCompany[]>([]);
  const [filteredClientCompanyData, setfilteredClientCompanyData] = useState<ClientAccountCompany[]>([]);
  const [selectedClientCompany, setSelectedClientCompany] = useState<ClientAccountCompany | null>(null);
  const [companySearchKey, setCompanySearchKey] = useState<string>("");
  const [showCompanyListModal, setShowCompanyListModal] = useState<boolean>(false);
  const [customCreateLoading, setCustomCreateLoading] = useState<boolean>(false);
  const [customCompanyName, setCustomCompanyName] = useState<string>("");
  const [customCompanyNameError, setCustomCompanyNameError] = useState<string>("");
  const [assignLoading, setAssignLoading] = useState<boolean>(false);

  /* For swaping account */
  const [selectedAccounts, setSelectedAccounts] = useState<ClientAccountType[]>([]);
  const [showAccountMoveModal, setShowAccountMoveModal] = useState<boolean>(false);
  const [accountMoveLoading, setAccountMoveLoading] = useState<boolean>(false);
  const [selectedMovingTarget, setSelectedMovingTarget] = useState<ClientAccountCompany | null>(null);
  const [movingTargetSearchKey, setMovingTargetSearchKey] = useState<string>('');
  const [movingTargetList, setMovingTargetList] = useState<ClientAccountCompany[]>([]);

  // need to load all project informations
  const [navigateFrom, setNavigateFrom] = useState<string | null>(null);

  const [projectContactIds, setProjectContactIds] = useState<number[]>([]);

  //shared list contents
  const [sharedList, setSharedList] = useState<ShareContactType[]>([]);

  // restore project information.
  useEffect(() => {
    if (location.state && location.state.openStatus) {
      const status: number = location.state.openStatus;
      setAddOptions(status);
    }

    if (location?.state && location?.state?.navigateFrom) {
      setNavigateFrom(location?.state?.navigateFrom)
    } else {
      setNavigateFrom(null);
    }
  }, [location.state]);

  useEffect(() => {
    if (addOptions === 1) {
      //  open add form model.
      setShowClientAccountModal(true);
      setDataState("Add");
    }
  }, [addOptions]);

  // PERMISION HANDLER
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  
 // CHANGE 2
  const canEditGbl = location.state.projectData ? (location?.state?.projectData?.can_edit === true) : (clientAccountDetails && clientAccountDetails.can_edit === true);

  const add_data = (useCanEdit("Client Account", "add_account_details") || canEditGbl);
  const edit_data = (useCanEdit("Client Account", "edit_account_details") || canEditGbl);
  const delete_data = (useCanEdit("Client Account", "delete_account_details") || canEditGbl);
  const share_data = useCanEdit("Client Account", "share_account_details");

  // for the resons
  const dispatch = useAppDispatch();

    // CHANGE 3
  useEffect(() => {
    const fetchUserRole = async () => {
      const roleName = await getLoginUserRoleName();
      setLoginUserRoleName(roleName);
    };

    fetchUserRole();
  }, []);


  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    dispatch(getAllClientProjectList());
    dispatch(getAllCompanyList());
  }, [dispatch]);

  // this is get data from state list and set projectlist
  const ProjectsList = useAppSelector((state) => state.clientAccount.clientAccountProjectList);
  const CompanyList = useAppSelector((state) => state?.clientAccountCompany.companyList);

  // restore project information.
  // useEffect(() => {
  //   if (location.state && location.state.projectData) {
  //     const globleProject = location.state.projectData as ClientAccountProjectType;

  //     setOwanProject(globleProject.is_own_project!);

  //     const updatedProject = ProjectsList.filter(
  //       (e) => e.project_id === globleProject.project_id
  //     );

  //     if (updatedProject.length > 0) {
  //       setClientAccountDetails(updatedProject[0] as ClientAccountProjectType);
  //     } else {
  //       setClientAccountDetails(globleProject);
  //     }
  //   }
  // }, [location.state, ProjectsList]);



  
 // CHANGE-4
  // find project from globle object list.
  useEffect(() => {
    if (loginUserRoleName === "commercial client" || loginUserRoleName === "domestic client") {
      if (ProjectsList && ProjectsList?.length > 0) {
        setClientAccountDetails(ProjectsList[0]);
        setOwanProject(ProjectsList[0]?.is_own_project!);
      } else {
        navigate('/client-account/projects')
      }
    } else {

      if (location.state.projectData) {
        const globleproject = location.state.projectData as ClientAccountProjectType;
        // get login user type here
        setOwanProject(globleproject?.is_own_project!);
        const projectfromState = ProjectsList.filter(
          (e) => e.project_id === globleproject.project_id
        );
        if (projectfromState.length > 0) {
          setClientAccountDetails(projectfromState[0]);
        } else {
          setClientAccountDetails(globleproject);
        }
      }
    }


  }, [ProjectsList, location.state]);


  /* Contact */
  useEffect(() => {
    // const globleproject = location.state.projectData as ClientAccountProjectType;
    setClientAccountContactsData(clientAccountDetails?.contact || []);
    // setClientAccountShareData(globleproject?.share_list || []);
    setCompanyData(clientAccountDetails?.company_list || []);
  }, [clientAccountDetails]);

  // // reupdate
  // useEffect(() => {
  //   const globleproject = location.state.projectData as ClientAccountProjectType;

  //   const projectfromState = ProjectsList.filter(
  //     (e) => e.project_id === globleproject.project_id
  //   );

  //   if (projectfromState.length > 0) {
  //     const projectx = projectfromState[0];
  //     const fetchData = async () => {
  //       // setClientAccountContactsData(projectx?.contact || []);
  //       // recall
  //       // setClientAccountShareData(projectx?.share_list || []);

  //       setCompanyData(projectx?.company_list || []);
  //       // setCheckedContacts(globleproject.share_list.map((e) => e.id));
  //     };
  //     fetchData();
  //   }
  // }, [ProjectsList, location.state]);




  // project contact ids set
  useEffect(() => {
    setClientAccountContactsData(clientAccountDetails?.contact || []);
  }, [clientAccountDetails])

  useEffect(() => {
    if (clientAccountContactsData && clientAccountContactsData.length > 0) {
      const ids = clientAccountContactsData.map((e) => e.id)
      setProjectContactIds(ids);
    }
  }, [clientAccountContactsData])


  // refill shared list data
  useEffect(() => {
    if (!clientAccountDetails) return;
    const shareList = clientAccountDetails.share_list ?? [];
    if (shareList.length > 0) {
      const results: ShareContactType[] = shareList.map((e) => {
        const dt: Partial<ShareContactType> = {
          id: e.id,
          first_name: e.first_name,
          last_name: e.last_name!,
          profile_image: e.profile_image,
          email: e.email!,
          type: e.main_type!,
          by: e.by,
          can_edit: e.can_edit,
          can_view: 1, // forcing as "viewable"
        };

        return mapShareContactType(dt);
      });

      setSharedList(results);
    } else {
      setSharedList([]); // clear if no share list
    }
  }, [clientAccountDetails]);





  useEffect(() => {
    if (clientAccountDetails && clientAccountDetails !== null) {
      setClientAccountData(clientAccountDetails?.data || []);
      setCompanyData(clientAccountDetails?.company_list || []);
      // setClientAccountContactsData(clientAccountDetails?.contact || []);
      // recall
      // setClientAccountShareData(clientAccountDetails?.share_list || []);
    } else {
      setClientAccountData([]);
      setCompanyData([]);
      // setClientAccountContactsData([]);
      setClientAccountShareData([]);
    }
  }, [clientAccountDetails]);

  useEffect(() => {
    if (clientAccountData && clientAccountData?.length > 0) {
      if (accountType === "My account") {
        const filteredData = clientAccountData.filter((account) => account.account_type === "My account");
        setClientAccountDataByType(filteredData);
      } else if (accountType === "Company account") {
        if (selectedCompany && selectedCompany !== null) {
          const filteredData = clientAccountData.filter((account) => account.account_type === "Company account" && account.company_id === selectedCompany.id);
          setClientAccountDataByType(filteredData);
        }
      }
    }
  }, [clientAccountData, accountType, selectedCompany]);

  useEffect(() => {
    if (clientAccountDataByType && clientAccountDataByType?.length > 0) {
      if (accountState === "Order") {
        const filteredData = clientAccountDataByType.filter((account) =>
          account
            ?.title!.toLowerCase()
            .includes(clientAccountSearchKey.toLowerCase())
        );
        setFilteredClientAccountData(filteredData);

        setClientAccountSubtotal(
          filteredData.reduce((acc, curr) => acc + (curr.amount || 0), 0)
        );
      }

      if (accountState === "Cash") {
        const filteredData = clientAccountDataByType.filter(
          (account) =>
            account.account_for === "Cash" &&
            account
              ?.title!.toLowerCase()
              .includes(clientAccountSearchKey.toLowerCase())
        );
        setFilteredClientAccountData(filteredData);
        setClientAccountSubtotal(
          filteredData.reduce((acc, curr) => acc + (curr.amount || 0), 0)
        );
      }

      if (accountState === "Credit") {
        const filteredData = clientAccountDataByType.filter(
          (account) =>
            account.account_for === "Credit" &&
            account
              ?.title!.toLowerCase()
              .includes(clientAccountSearchKey.toLowerCase())
        );

        let filteredCreditData: ClientAccountType[] = [];

        if (creditAccountState === 'All') {
          filteredCreditData = filteredData;
        } else if (creditAccountState === 'Settled') {
          filteredCreditData = filteredData.filter((account) => account.is_settled === 1);
        } else if (creditAccountState === 'Unsettled') {
          filteredCreditData = filteredData.filter((account) => account.is_settled === 0);
        }

        setFilteredClientAccountData(filteredCreditData);

        setClientAccountSubtotal(
          filteredCreditData.reduce((acc, curr) => acc + ((curr.cash === "In" ? curr.amount : curr.amount! * -1) || 0), 0)
        );
      }
    } else {
      setFilteredClientAccountData([]);
      setClientAccountSubtotal(0);
    }
  }, [clientAccountDataByType, accountState, clientAccountSearchKey, creditAccountState]);


  /* ***************************** Client account ****************************** */
  const handleCloseClientAccountModal = () => {
    setShowClientAccountModal(false);

    handleClearClientAccountFormFields();
    handleClearMPurchaseErrors();
  };

  const handleClearClientAccountFormFields = () => {
    setAccountDate(today);
    setCashStatus(null);
    setAccountTitle("");
    setAccountAmount(null);
    setAccountFile(null);
    setAccountFileName("");
  };

  const handleClearMPurchaseErrors = () => {
    setAccountDateError("");
    setCashStatusError("");
    setAccountTitleError("");
    setAccountAmountError("");
    setAccountFileError("");
  };

  const handleAddAccountDetail = () => {
    setShowClientAccountModal(true);
    setDataState("Add");
    setAccountAddState("Cash");
  };



  // validation text handler for mpurchase

  useEffect(() => {
    checkText(accountTitle, false, setAccountTitleError);
  }, [accountTitle]);

  useEffect(() => {
    checkNumberForAmount(accountAmount!, false, setAccountAmountError);
  }, [accountAmount]);

  function checkCredentials(): boolean {
    const isDate = checkText(formatDate(accountDate!), true, setAccountDateError);
    const title = checkText(accountTitle, true, setAccountTitleError);
    const amount = checkNumberForAmount(accountAmount!, true, setAccountAmountError);
    const file = checkFileOthers(accountFile!, false, setAccountFileError);

    return isDate && title && amount && file;
  }

  // create function client account details
  const handleCreateAccountDetail = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);
      const data = await createClientAccount(
        clientAccountDetails?.project_id!,
        selectedCompany?.id || null,
        accountAddState,
        formatDate(accountDate!),
        cashStatus,
        accountType,
        accountTitle,
        accountAmount!,
        accountFile!
      );
      setLoading(false);

      if (data.statusCode === 200) {
        // call project dispach event
        dispatch(getAllClientProjectList());
        handleCloseClientAccountModal();
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Account details added successfully.",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error adding the account details.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleEditAccountDetail = (data: ClientAccountType) => {
    if (data) {
      setSelectedClientAccount(data);
      setShowClientAccountModal(true);
      setDataState("Edit");

      setAccountAddState(data?.account_for!);
      setAccountDate(parseStringToDate(data?.date!) || null);
      setCashStatus(data?.cash || null);
      setAccountTitle(data?.title || "");
      setAccountAmount(data?.amount || null);
    } else {
      setSelectedClientAccount(null);

      setAccountAddState('Cash');
      setAccountDate(null);
      setCashStatus(null);
      setAccountTitle("");
      setAccountAmount(null);
    }
  };

  // update function for client account details
  const handleUpdateAccountDetail = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);
      const data = await updateClientAccount(
        accountAddState,
        clientAccountDetails?.project_id!,
        formatDate(accountDate!),
        cashStatus,
        accountTitle,
        accountAmount!,
        accountFile!,
        selectedClientAccount?.id!
      );
      setLoading(false);

      if (data.statusCode === 200) {
        // call project dispach event
        dispatch(getAllClientProjectList());
        handleCloseClientAccountModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Account details updated successfully.",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the account details.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteAccountDetail = (data: ClientAccountType) => {
    const accountId = data?.id;

    confirmDialog({
      message: "Are you sure you want to delete this record?",
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteAccountDetail(accountId!),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  };

  // delete function for client account details.
  const deleteAccountDetail = async (accountId: number) => {
    const result = await deleteClientAccount(accountId);

    if (result.statusCode === 200) {
      dispatch(getAllClientProjectList());

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Record deleted successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the record.",
          life: 3000,
        });
      }
    }
  };

  const accountModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} details -
        &nbsp;{accountType === 'My account' ? accountType : selectedCompany?.company_name}
      </h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseClientAccountModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const accountModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseClientAccountModal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}`}
        onClick={dataState === "Add" ? handleCreateAccountDetail : handleUpdateAccountDetail}
        loading={loading}
        className="custom_btn primary"
      />
    </div>
  );

  const handleAccountFileUpload = (file: File) => {
    setAccountFile(file);
    setAccountFileName(file.name);
  };

  const handleClearAccountFile = () => {
    setAccountFile(null);
    setAccountFileName("");
  };

  const handleAccountAmountChange = (e: InputNumberChangeEvent) => {
    if (e.value !== null) {
      setAccountAmount(e.value);
    } else {
      setAccountAmount(null);
    }
  };

  const accountFileBody = (rowData: ClientAccountType) => {
    const data = rowData;
    const file = data?.file;
    const fileExt = data?.file_extension;

    return (
      <div className="table_file_view_area">
        {file && file !== null ? (
          <React.Fragment>
            {fileExt === "pdf" ? (
              <div
                className="item_file_container"
                onClick={(e) => {
                  e.stopPropagation();
                  handleViewDocumentFile(file!);
                }}
              >
                <i className="bi bi-file-earmark-pdf doc_icon"></i>
              </div>
            ) : (
              <div className="note_image_container">
                <Image src={baseURL + file} className="note_img" preview />
              </div>
            )}
          </React.Fragment>
        ) : (
          <span className="no_image_text">---</span>
        )}
      </div>
    );
  };

  const tableActionBody = (rowData: ClientAccountType) => {
    const data = rowData;
    return (
      <React.Fragment>
        <Tooltip
          key={`edit_${rowData?.id}`}
          id={`edit_${rowData?.id}`}
          target={`.edit_${rowData?.id}`}
        />
        <Tooltip
          key={`delete_${rowData?.id}`}
          id={`delete_${rowData?.id}`}
          target={`.delete_${rowData?.id}`}
        />

        <div className="tabel_btn_area custom mt-1 mb-1">
          {((edit_data && owanProject) || (clientAccountDetails?.can_edit !== null && clientAccountDetails?.can_edit === true)) && (
            <button
              className={`data_action_btn with_bg primary_table_btn edit_${rowData?.id} p-ripple`}
              onClick={() => handleEditAccountDetail(data)}
              data-pr-tooltip={`Edit`}
              data-pr-position="top"
            >
              <i className="bi bi-pencil-square"></i>
              <Ripple />
            </button>
          )}

          {((delete_data && owanProject) || (clientAccountDetails?.can_edit !== null && clientAccountDetails?.can_edit === true)) && (
            <button
              className={`data_action_btn with_bg danger_table_btn delete_${rowData?.id} p-ripple`}
              onClick={() => handleDeleteAccountDetail(data)}
              data-pr-tooltip={`Delete`}
              data-pr-position="top"
            >
              <i className="bi bi-trash3"></i>
              <Ripple />
            </button>
          )}

        </div>
      </React.Fragment>
    );
  };

  const handleChangeCashStatus = (e: CheckboxChangeEvent, option: "In" | "Out") => {
    setCashStatus(option);
  };

  const handleChangeOrderType = (e: CheckboxChangeEvent, option: "Cash" | "Credit") => {
    setAccountAddState(option);

    if (option === 'Cash') {
      setCashStatus(null);
    } else if (option === 'Credit') {
      setCashStatus("In");
    }
  };

  const handleChangeSettlementStatus = (newStatus: boolean, rowData: ClientAccountType) => {
    confirmDialog({
      message: `Are you sure, you want to make this account ${newStatus === true ? 'settled' : 'unsettled'}?`,
      header: "Confirm Status Change",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      dismissableMask: true,
      resizable: false,
      draggable: false,
      accept: () => handleUpdateSettlementStatus(rowData, newStatus),
      reject: () => { },
    });
  };

  const handleUpdateSettlementStatus = async (account: ClientAccountType, newStatus: boolean) => {
    const settledStatus = newStatus ? 1 : 0;
    const result = await updateSettlementStatus(account?.id!, settledStatus);

    if (result.statusCode === 200) {
      dispatch(getAllClientProjectList());
      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Account status updated successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: `There was an error updating the account status.`,
          life: 3000,
        });
      }
    }
  }

  const settlementStatusBody = (rowData: ClientAccountType) => {
    return (
      <React.Fragment>
        {((clientAccountDetails?.can_edit !== null && clientAccountDetails?.can_edit === true)) && (<div className="input_switch_area">
          <InputSwitch
            className="custom_input_switch theme_success"
            checked={rowData?.is_settled === 1}
            onChange={(e) => handleChangeSettlementStatus(e.value, rowData)}
            tooltip={`${rowData?.is_settled === 1 ? "Settled" : "Unsettled"}`}
            tooltipOptions={{ position: "top" }}
          />
        </div>)}
      </React.Fragment>

    );
  };

  useEffect(() => {
    const myAccountOption: ClientAccountCompany = {
      id: null,
      company_name: 'My account',
      account_name: '',
      sort_code: '',
      account_no: '',
    };

    setAccountForList([myAccountOption, ...companyData]);

    if (accountType === 'My account' && selectedCompany === null) {
      setSelectedAccountFor(myAccountOption);
    }

    if (accountType === 'Company account' && selectedCompany !== null) {
      setSelectedAccountFor(selectedCompany);
    }
  }, [companyData, accountType, selectedCompany])

  const handleChangeAccountFor = (e: DropdownChangeEvent) => {
    setSelectedCompany(e.value as ClientAccountCompany);
    setSelectedAccountFor(e.value as ClientAccountCompany);
    goToTop();
  };

  useEffect(() => {
    if (selectedAccountFor && selectedAccountFor !== null) {
      if (selectedAccountFor?.id === null) {
        handleChangeAccountType("My account");
        setSelectedCompany(null);
      } else {
        handleChangeAccountType("Company account");
      }
    }
  }, [selectedAccountFor]);

  const accountForOptionFooterTemplate = () => {
    return (
      <div className="option_footer_area">
        <button
          className={`add_data_btn p-ripple`}
          onClick={() => {
            handleAddCompany();
            dropdownRef.current?.hide();
          }}
        >
          <i className={`bi bi-plus-circle-fill`}></i>
          Add company
          < Ripple />
        </button>
      </div>
    )
  }
  /* *************************************************************************** */

  /* View document file */
  const handleCloseDocViewModal = () => {
    setShowDocViewModal(false);
    setDocumentFileUrl("");
  };

  const handleViewDocumentFile = (fileUrl: string) => {
    if (fileUrl && fileUrl !== "") {
      setShowDocViewModal(true);
      setDocumentFileUrl(baseURL + fileUrl);
    } else {
      setShowDocViewModal(false);
      setDocumentFileUrl("");
    }
  };
  /*  */

  /* ********************************* Contact ********************************* */

  const handleShareToProjectContact = () => {
    setShowContactShareModal(true);
    handleResetContactFields();
  };

  const handleCloseShareContactModal = () => {
    setShowContactShareModal(false);
  };

  const handleResetContactFields = () => {
    setActiveContactTab("All");
  };




  /* Share  */
  const handleCloseShareModal = () => {
    setShowContactShareModal(false);
  }

  const handleShareQuotation = () => {
    setShowContactShareModal(true);
    // setSelectedProject(project);
  }

  // database function
  const shareDataFunction = async (selectedContacts: ShareContactType[]) => {
    try {
      // get only ticked data as well
      const sendData = selectedContacts.filter((e) => e.can_view != 0)
     if ((sendData && sendData?.length > 0) || true) {
        setLoading(true);
        const data = await shareProjectClientAccount(
          sendData,
          clientAccountDetails?.project_id!

        );
        setLoading(false);
        if (data.statusCode === 200) {
          handleCloseShareModal();
          dispatch(getAllClientProjectList());

          if (toast.current) {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Client account shared successfully.',
              life: 3000
            });
          }
        }
      }

    } catch (error) {
      setLoading(false);

      if (toast.current) {
        toast.current.show({
          severity: 'error',
          summary: 'Failed',
          detail: 'There was an error sharing the quotation.',
          life: 3000
        });
      }
    }
  }
  /*  */



  const handleSwichContactType = (tab: "All" | "Employee" | "Professional" | "Client") => {
    setActiveContactTab(tab);
  };


  /* *************************************************************************** */


  /* ******************************* Account state ***************************** */
  const handleChangeAccountState = (state: 'Order' | 'Cash' | 'Credit') => {
    setAccountState(state);
    setClientAccountSearchKey("");

    if (state === 'Credit') {
      setCreditAccountState("All");
    }
  }

  const handleToggleAccountAddState = (state: 'Cash' | 'Credit') => {
    setAccountAddState(state);

    if (state === 'Cash') {
      setCashStatus(null);
    } else if (state === 'Credit') {
      setCashStatus("In");
    }
  }

  const handleChangeCreditAccountState = (state: 'All' | 'Settled' | 'Unsettled') => {
    setCreditAccountState(state);
  }
  /* *************************************************************************** */


  /* ******************************* Account type ****************************** */
  const handleChangeAccountType = (type: 'My account' | 'Company account') => {
    setAccountType(type);
    setSelectedAccounts([]);
  }
  /* *************************************************************************** */


  /* ******************************* Move account ****************************** */
  useEffect(() => {
    if (companyData && companyData?.length > 0) {
      const myAccountOption: ClientAccountCompany = {
        id: null,
        company_name: 'My account',
        account_name: '',
        sort_code: '',
        account_no: '',
      };

      let initialData = [myAccountOption, ...companyData];

      let validData = initialData;

      if (accountType === 'Company account' && selectedCompany !== null) {
        validData = validData.filter(data => data.id !== selectedCompany?.id);
      }

      if (accountType === 'My account' && selectedCompany === null) {
        validData = validData.filter(data => data.id !== null);
      }

      let filteredData = validData.filter(data =>
        data?.company_name?.toLowerCase().includes(movingTargetSearchKey.toLowerCase())
      );

      setMovingTargetList(filteredData);
    }
  }, [companyData, movingTargetSearchKey, selectedCompany, accountType]);

  const handleCloseAccountMoveModal = () => {
    setShowAccountMoveModal(false);
    setMovingTargetSearchKey("");

    setSelectedMovingTarget(null);
  };

  const handleMoveAccount = () => {
    setShowAccountMoveModal(true);
  }

  const handleSelecteMoveTarget = (target: ClientAccountCompany | null) => {
    setSelectedMovingTarget(target);
  }

  const moveAccountConfirmation = () => {
    confirmDialog({
      message: `Are you sure you want to move these selected accounts to ${selectedMovingTarget?.company_name}`,
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => moveAccount(),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  }

  const moveAccount = async () => {
    if (selectedAccounts && selectedAccounts?.length > 0) {
      setAccountMoveLoading(true);

      const data = await moveClientAccount(
        selectedMovingTarget?.id!,
        selectedAccounts
      );

      setAccountMoveLoading(false);

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getAllClientProjectList());

        handleCloseAccountMoveModal();
        setAccountMoveLoading(false);
        setSelectedAccounts([]);

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Selected account(s) moved successfully.",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error moving the account(s).",
            life: 3000,
          });
        }
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "warn",
          summary: "Warning",
          detail: "Select the account or accounts to move.",
          life: 3000,
        });
      }
    }
  }
  /* *************************************************************************** */


  /* ********************************* Company ********************************* */
  useEffect(() => {
    if (CompanyList && CompanyList?.length > 0) {
      /* Skip already added companies */
      // const excludedCompanyIds = companyData.map(company => company.id);
      // const availableCompanies = CompanyList.filter(company => !excludedCompanyIds.includes(company.id));

      setClientCompanyList(CompanyList);
    }
  }, [CompanyList, companyData]);

  useEffect(() => {
    if (clientCompanyList && clientCompanyList?.length > 0) {
      const filteredData = clientCompanyList?.filter((company) =>
        company
          ?.company_name!.toLowerCase()
          .includes(companySearchKey.toLowerCase())
      );

      setfilteredClientCompanyData(filteredData);
    }
  }, [clientCompanyList, companySearchKey]);

  const handleCloseCompanyListModal = () => {
    setShowCompanyListModal(false);
    setCompanySearchKey("");

    handleClearCustomCompanyFields();
  };

  const handleClearCustomCompanyFields = () => {
    setCustomCompanyName("");
    setCustomCompanyNameError("");
  };

  const handleAddClientCompany = () => {
    setShowCompanyListModal(true);

    dispatch(getAllCompanyList());
  };

  const handleResetCompanyFields = () => {
    setCompanyName("");
    setAccountName("");
    setSortCode("");
    setAccountNumber("");
  }

  const handleResetCompanyErrors = () => {
    setCompanyNameError("");
    setAccountNameError("");
    setSortCodeError("");
    setAccountNumberError("");
  }

  const handleSelectCompany = (company: ClientAccountCompany) => {
    handleResetCompanyFields();
    handleResetCompanyErrors();
    setSelectedClientCompany(null);

    if (company) {
      setSelectedClientCompany(company);

      setCompanyName(company?.company_name || "");
      setAccountName(company?.account_name || "");
      setSortCode(company?.sort_code || "");
      setAccountNumber(company?.account_no || "");
    }

    setTimeout(() => {
      handleCloseCompanyListModal();
    }, 400);
  };
  /*  */

  /* Create custom company */
  useEffect(() => {
    checkText(customCompanyName, false, setCustomCompanyNameError);
  }, [customCompanyName]);

  function checkCustomCompanyCredentials(): boolean {
    const custom_company_name = checkText(customCompanyName, true, setCustomCompanyNameError);

    return custom_company_name;
  }

  function showAPIErrorCustomCompanyData(keyName: string, error: string): void {
    if (keyName === "company_name") {
      setCustomCompanyNameError(error);
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error creating the company.",
          life: 3000,
        });
      }
    }
  }

  const handleCreateCustomCompany = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCustomCompanyCredentials()) {
      setCustomCreateLoading(true);
      const data = await createCompany(customCompanyName);

      setCustomCreateLoading(false);

      if (data.statusCode === 200) {
        // call company dispach event
        dispatch(getAllCompanyList());

        setTimeout(() => {
          if (companyListRef.current) {
            companyListRef.current.scrollTo({
              top: companyListRef.current.scrollHeight + 40,
              behavior: 'smooth',
            });
          }
        }, 100);

        setCustomCreateLoading(false);
        handleClearCustomCompanyFields();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Company created successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrorCustomCompanyData(key, value[0])
        ))
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating the company.",
            life: 3000,
          });
        }
      }
    }
  }

  const handleCloseCompanyModal = () => {
    setShowCompanyModal(false);

    handleResetCompanyFields();
    handleResetCompanyErrors();
    setSelectedClientCompany(null);
  };

  useEffect(() => {
    checkText(companyName, false, setCompanyNameError);
  }, [companyName]);

  useEffect(() => {
    checkText(accountName, false, setAccountNameError);
  }, [accountName]);

  useEffect(() => {
    checkText(sortCode, false, setSortCodeError);
  }, [sortCode]);

  useEffect(() => {
    checkText(accountNumber, false, setAccountNumberError);
  }, [accountNumber]);

  function checkCompanyCredentials(): boolean {
    const company_name = checkText(companyName, true, setCompanyNameError);
    const account_name = checkText(accountName, false, setAccountNameError);
    const sort_code = checkText(sortCode, false, setSortCodeError);
    const account_no = checkText(accountNumber, false, setAccountNumberError);

    return company_name && account_name && sort_code && account_no;
  }

  function showAPIErrorCompanyData(keyName: string, error: string): void {
    if (keyName === "company_name") {
      setCompanyNameError(error);
    }
    if (keyName === "account_name") {
      setAccountNameError(error);
    }
    if (keyName === "sort_code") {
      setSortCodeError(error);
    }
    if (keyName === "account_no") {
      setAccountNumberError(error);
    }
  }

  /* Add company */
  const handleAddCompany = () => {
    setShowCompanyModal(true);
    setDataState("Add");
  };

  const handleAssignCompany = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCompanyCredentials()) {
      setAssignLoading(true);
      const data = await assignCompany(
        clientAccountDetails?.project_id!,
        selectedClientCompany?.id!,
        companyName,
        accountName,
        sortCode,
        accountNumber,
      );

      setAssignLoading(false);

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getAllClientProjectList());
        dispatch(getAllCompanyList());

        setAssignLoading(false);
        handleCloseCompanyModal();
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Company added successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrorCompanyData(key, value[0])
        ))
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error adding the company.",
            life: 3000,
          });
        }
      }
    }
  }
  /*  */

  /* Edit company */
  const handleEditCompany = () => {
    setShowCompanyModal(true);
    setDataState("Edit");

    if (selectedCompany) {
      setCompanyName(selectedCompany?.company_name || "");
      setAccountName(selectedCompany?.account_name || "");
      setSortCode(selectedCompany?.sort_code || "");
      setAccountNumber(selectedCompany?.account_no || "");
    }
  }

  useEffect(() => {
    const updatedCompany = companyData.find((company) => company.id === selectedCompany?.id);
    if (updatedCompany) {
      setSelectedCompany(updatedCompany);
    }
  }, [companyData, selectedCompany]);

  const handleUpdateCompany = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCompanyCredentials()) {
      setAssignLoading(true);
      const data = await updateCompany(
        clientAccountDetails?.project_id!,
        selectedCompany?.id!,
        companyName,
        accountName,
        sortCode,
        accountNumber
      );

      setAssignLoading(false);

      if (data.statusCode === 200) {
        // call project dispach event
        dispatch(getAllClientProjectList());

        setAssignLoading(false);
        handleCloseCompanyModal();
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Company details updated successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrorCompanyData(key, value[0])
        ))
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the company details.",
            life: 3000,
          });
        }
      }
    }
  }
  /*  */

  /* View company */
  const handleCloseCompanyViewModal = () => {
    setShowCompanyViewModal(false);
  }

  const handleViewCompany = () => {
    setShowCompanyViewModal(true);
  }

  const companyViewModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">
        Company details
      </h5>
      <button type="button" className="close_modal_btn p-ripple"
        onClick={handleCloseCompanyViewModal}>
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  )
  /*  */

  const companyModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} company</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseCompanyModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const companyModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseCompanyModal}
      />

      <Button
        label={`${assignLoading ? "Processing" : dataState === 'Add' ? "Add" : "Update"}`}
        onClick={dataState === 'Add' ? handleAssignCompany : handleUpdateCompany}
        loading={assignLoading}
        className="custom_btn primary"
        disabled={dataState === 'Edit' && !companyUpdateHasChanges}
      />
    </div>
  );

  const handleSortCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;

    const numericInput = input.replace(/\D/g, '');

    if (numericInput.length <= 6) {
      setSortCode(numericInput);
    }
  };

  useEffect(() => {
    const normalize = (value: string | null | undefined) => value ?? '';

    const hasChanges =
      companyName !== normalize(selectedCompany?.company_name) ||
      accountName !== normalize(selectedCompany?.account_name) ||
      sortCode !== normalize(selectedCompany?.sort_code) ||
      accountNumber !== normalize(selectedCompany?.account_no);

    setCompanyUpdateHasChanges(hasChanges);
  }, [companyName, accountName, sortCode, accountNumber, selectedCompany]);
  /* *************************************************************************** */


  /* **************************** Common functions ***************************** */
  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {loadingPage ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            <div className="page_breadcrumb_area">

              {navigateFrom && navigateFrom === 'Project' ? (
                <ul className="page_breadcrumb">
                  <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                    {clientAccountDetails?.job_number + ": " + clientAccountDetails?.address}
                  </li>
                  <li className="page_breadcrumb_item active">
                    Client account
                  </li>
                </ul>
              ) : (
                <ul className="page_breadcrumb">
                  <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                    Projects
                  </li>
                  
                  
                  {/* <li className="page_breadcrumb_item has_child">
                    {clientAccountDetails?.job_number + ": " + clientAccountDetails?.address}
                  </li> */}

                    {/* CHANGE 5 */}
                                    {(ProjectsList && ProjectsList?.length === 1) ? (<li className="page_breadcrumb_item has_child">
                                      {clientAccountDetails?.job_number + ": " + clientAccountDetails?.address}
                                    </li>) : (((loginUserRoleName === "domestic client") || loginUserRoleName === "commercial client")) ? (<li> <Dropdown
                                      key={`projectKey`}
                                      id="projectKey"
                                      value={clientAccountDetails}
                                      onChange={(e: DropdownChangeEvent) => setClientAccountDetails(e.value)}
                                      optionLabel="address"
                                      options={ProjectsList}
                                      panelClassName="status_option_panel"
                                      placeholder="Select collection"
                                      className="form_dropdown w-100"
                                    // loading={loadingFSKitchenCollections}
                                    /> </li>) : (<li className="page_breadcrumb_item has_child">
                                      {clientAccountDetails?.job_number + ": " + clientAccountDetails?.address}
                                    </li>)}




                  <li className="page_breadcrumb_item active">
                    Client account
                  </li>
                </ul>
              )}

              <button className="back_btn p-ripple" onClick={goBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Back
                <Ripple />
              </button>
            </div>

            <div className="page_header_area scrollable custom_wrap">
              <div className="main_heading_tab_area custom">
                <button
                  className={`main_heading_as_tab is_tab ${accountType === "My account" ? "active" : ''} p-ripple is_btn`}
                  type="button"
                  role="tab"
                  onClick={() => {
                    handleChangeAccountType("My account");
                    setSelectedCompany(null);
                  }}
                >
                  My Account
                  <Ripple />
                </button>

                <div className="tab_divider"></div>

                {companyData && companyData.length > 0 && (
                  <React.Fragment>
                    {companyData?.map((company) => (
                      <React.Fragment>
                        <button
                          key={company.id}
                          className={`main_heading_as_tab is_tab ${(accountType === "Company account" && selectedCompany?.id === company?.id) ? "active" : ''} p-ripple is_btn text-capitalize`}
                          type="button"
                          role="tab"
                          onClick={() => {
                            handleChangeAccountType("Company account");
                            setSelectedCompany(company);
                          }}
                        >
                          {company.company_name}
                          < Ripple />
                        </button>

                        <div className="tab_divider"></div>
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                )}

                {(clientAccountDetails?.shared_by === null) && (
                  <Button
                    type="button"
                    icon="bi bi-plus-circle"
                    tooltip="Add company"
                    label="Add"
                    className="add_tab_btn with_lbl"
                    tooltipOptions={{ position: 'top' }}
                    onClick={handleAddCompany}
                  />
                )}
              </div>

              <div className="page_action_area d-none d-sm-flex">
                {(clientAccountDetails?.shared_by === null) && (
                  <button
                    className="add_data_link_btn custom p-ripple"
                    onClick={handleMoveAccount}
                    disabled={selectedAccounts?.length === 0}
                  >
                    <i className="bi bi-arrow-left-right"></i>
                    <span className="btn_text">Move</span>
                    <Ripple />
                  </button>
                )}

                {(share_data && owanProject) && (
                  <button
                    className="add_data_link_btn custom p-ripple"
                    onClick={handleShareQuotation}
                  >
                    <i className="bi bi-share-fill"></i>
                    <span className="btn_text">Share</span>
                    <Ripple />
                  </button>
                )}
              </div>
            </div>

            <div className="page_header_area mt-sm-3 mt-3">
              <div className="contact_tabs custom">
                <div className="contact_tab_item">
                  <button
                    type="button"
                    className={`contact_tab_btn min_width status_tab ${accountState === "Order" ? "active" : ""} p-ripple`}
                    onClick={() => handleChangeAccountState("Order")}
                  >
                    Order
                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                  </button>
                </div>

                <div className="contact_tab_item">
                  <button
                    type="button"
                    className={`contact_tab_btn min_width status_tab ${accountState === "Cash" ? "active" : ""} p-ripple`}
                    onClick={() => handleChangeAccountState("Cash")}
                  >
                    Cash
                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                  </button>
                </div>

                <div className="contact_tab_item">
                  <button
                    type="button"
                    className={`contact_tab_btn min_width status_tab ${accountState === "Credit" ? "active" : ""} p-ripple`}
                    onClick={() => handleChangeAccountState("Credit")}
                  >
                    Credit
                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                  </button>
                </div>
              </div>

              <div className="page_action_area full_width custom">
                {accountType === 'Company account' && (
                  <React.Fragment>
                    <Tooltip
                      key={`company_detail`}
                      id={`company_detail`}
                      target={`.company_detail`}
                    />
                    <button
                      className="add_data_link_btn company_detail d-none d-sm-flex custom p-ripple"
                      onClick={handleViewCompany}
                      data-pr-tooltip={`View company details`}
                      data-pr-position="top"
                    >
                      <i className="bi bi-buildings"></i>
                      <Ripple />
                    </button>
                  </React.Fragment>
                )}

                <div className="display_label">
                  <span className="display_label_text">Subtotal :&nbsp;</span>
                  <span>
                    {currencySymbol}&nbsp;
                    {clientAccountSubtotal.toLocaleString("en-GB", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>

                <div className="filter_input_group custom">
                  <IconField iconPosition="right">
                    {clientAccountSearchKey === "" ? (
                      <InputIcon className="bi bi-search"></InputIcon>
                    ) : (
                      <InputIcon
                        className="bi bi-x-lg search_clear_icon"
                        onClick={() => setClientAccountSearchKey("")}
                      ></InputIcon>
                    )}

                    <InputText
                      key={`clientAccountSearchKey`}
                      id="clientAccountSearchKey"
                      value={clientAccountSearchKey}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setClientAccountSearchKey(e.target.value)
                      }
                      className="custom_form_input filter_input auto_width"
                      placeholder="Search by description"
                      type="search"
                    />
                  </IconField>
                </div>

                {accountType === 'Company account' && (
                  <React.Fragment>
                    <Tooltip
                      key={`company_detail`}
                      id={`company_detail`}
                      target={`.company_detail`}
                    />
                    <button
                      className="add_data_link_btn company_detail d-flex d-sm-none custom p-ripple"
                      onClick={handleViewCompany}
                      data-pr-tooltip={`View company details`}
                      data-pr-position="top"
                    >
                      <i className="bi bi-buildings"></i>
                      <Ripple />
                    </button>
                  </React.Fragment>
                )}

                {(clientAccountDetails?.shared_by === null) && (
                  <button
                    className="add_data_link_btn custom p-ripple d-sm-none"
                    onClick={handleMoveAccount}
                    disabled={selectedAccounts?.length === 0}
                  >
                    <i className="bi bi-arrow-left-right"></i>
                    <span className="btn_text">Move</span>
                    <Ripple />
                  </button>
                )}

                {(share_data && owanProject) && (
                  <button
                    className="add_data_link_btn custom p-ripple d-sm-none"
                    onClick={handleShareToProjectContact}
                  >
                    <i className="bi bi-share-fill"></i>
                    <span className="btn_text">Share</span>
                    <Ripple />
                  </button>
                )}

                {(((add_data && owanProject) || (clientAccountDetails?.can_edit !== null && clientAccountDetails?.can_edit === true))) && (
                  <button
                    className="add_data_link_btn p-ripple"
                    onClick={handleAddAccountDetail}
                  >
                    <i className="bi bi-plus-circle"></i>
                    <span>Add detail</span>
                    <Ripple />
                  </button>
                )}
              </div>
            </div>

            {clientAccountDetails && clientAccountDetails !== null && (
              <div className="page_main_content_section p-0">
                {accountState === 'Credit' && (
                  <div className="table_tab_filter_container">
                    <div className="table_tab_filter_area">
                      <button className={`table_filter_tab ${creditAccountState === "All" && " active"} p-ripple`}
                        type="button"
                        onClick={() => handleChangeCreditAccountState("All")}
                        role="tab"
                      >
                        All
                        <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                      </button>

                      <span className="table_filter_tab_divider"></span>

                      <button className={`table_filter_tab ${creditAccountState === "Settled" && " active"} p-ripple`}
                        type="button"
                        onClick={() => handleChangeCreditAccountState("Settled")}
                        role="tab"
                      >
                        Settled
                        <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                      </button>

                      <span className="table_filter_tab_divider"></span>

                      <button
                        className={`table_filter_tab ${creditAccountState === "Unsettled" &&
                          " active"
                          } p-ripple`}
                        type="button"
                        onClick={() => handleChangeCreditAccountState("Unsettled")}
                        role="tab"
                      >
                        Unsettled
                        <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                      </button>
                    </div>
                  </div>
                )}

                {clientAccountData && clientAccountData?.length > 0 ? (
                  <DataTable
                    value={filteredClientAccountData}
                    paginator
                    size="small"
                    rows={10}
                    emptyMessage="No records found!"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    tableStyle={{ minWidth: "50rem" }}
                    paginatorDropdownAppendTo={"self"}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    className="page_table p-0 p-sm-2"
                    rowHover
                    selectionMode={clientAccountDetails?.shared_by == null ? "multiple" : null}
                    dragSelection={clientAccountDetails?.shared_by === null ? true : false}
                    selection={selectedAccounts}
                    onSelectionChange={(e: DataTableSelectionMultipleChangeEvent<ClientAccountType[]>) => {
                      if (clientAccountDetails?.shared_by == null) {
                        setSelectedAccounts(e.value as ClientAccountType[]);
                      }
                    }}
                    dataKey="id"
                    scrollable
                  >
                    {(clientAccountDetails?.shared_by === null) && (
                      <Column
                        selectionMode="multiple"
                        headerStyle={{ width: "3rem" }}
                      ></Column>
                    )}

                    <Column
                      header="Date"
                      headerClassName="text_purple"
                      field="date"
                      body={(rowData: ClientAccountType) => (
                        <span className="text_no_wrap">
                          {rowData?.date ? rowData?.date : "---"}
                        </span>
                      )}
                      style={{ width: "15%" }}
                    ></Column>

                    <Column
                      header="Description"
                      headerClassName="text_purple title_column"
                      field="title"
                      body={(rowData: ClientAccountType) => (
                        <span className="text-capitalize">
                          {rowData?.title ? rowData?.title : "---"}
                        </span>
                      )}
                      style={{ width: "30%" }}
                    ></Column>

                    {accountState === 'Order' ? (
                      <Column
                        header="Amount"
                        headerClassName="text_purple"
                        alignHeader={"right"}
                        field="amount"
                        className="text_bold"
                        body={(rowData: ClientAccountType) => (
                          <span className={`text_no_wrap flex_end ${rowData?.account_for === "Cash" ? " text_success" : ' text_danger'}`}>
                            {currencySymbol}&nbsp;
                            {rowData?.amount
                              ? (rowData?.amount).toLocaleString("en-GB", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : "---"}
                          </span>
                        )}
                        style={{ width: "15%" }}
                      ></Column>
                    ) : accountState === 'Cash' ? (
                      <Column
                        header="Amount"
                        headerClassName="text_purple"
                        alignHeader={"right"}
                        field="amount"
                        className="text_bold"
                        body={(rowData: ClientAccountType) => (
                          <span className={`text_no_wrap flex_end text_success`}>
                            {currencySymbol}&nbsp;
                            {rowData?.amount
                              ? (rowData?.amount).toLocaleString("en-GB", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : "---"}
                          </span>
                        )}
                        style={{ width: "15%" }}
                      ></Column>
                    ) : (
                      <Column
                        header="Amount"
                        headerClassName="text_purple"
                        alignHeader={"right"}
                        field="amount"
                        className="text_bold"
                        body={(rowData: ClientAccountType) => (
                          <span className={`text_no_wrap flex_end ${rowData?.cash === "In" ? " text_success" : ''}`}>
                            {rowData?.cash === "In" ? '+ ' : rowData?.cash === "Out" ? '- ' : ''}
                            {currencySymbol}&nbsp;
                            {rowData?.amount
                              ? (rowData?.amount).toLocaleString("en-GB", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : "---"}
                          </span>
                        )}
                        style={{ width: "15%" }}
                      ></Column>
                    )}

                    {accountState === 'Order' ? (
                      <Column
                        header="Cash/Credit"
                        headerClassName="text_purple"
                        alignHeader={"center"}
                        field="cash"
                        body={(rowData: ClientAccountType) => (
                          <span className={`text_no_wrap flex_center text_bold text-center ${rowData?.account_for === "Cash" ? " text_success" : ' text_danger'}`}>
                            {rowData?.account_for ? rowData?.account_for : "---"}
                          </span>
                        )}
                        style={{ width: "10%" }}
                      ></Column>
                    ) : accountState === 'Credit' ? (
                      <Column
                        header="Cash"
                        headerClassName="text_purple"
                        alignHeader={"center"}
                        field="cash"
                        body={(rowData: ClientAccountType) => (
                          <span className={`text_no_wrap flex_center text_bold text-center ${rowData?.cash === "In" ? " text_success" : ''}`}>
                            {rowData?.cash ? rowData?.cash : "---"}
                          </span>
                        )}
                        style={{ width: "10%" }}
                      ></Column>
                    ) : null}

                    <Column
                      header="File"
                      headerClassName="text_purple"
                      alignHeader={"center"}
                      field="file"
                      body={accountFileBody}
                      style={{ width: "15%" }}
                    ></Column>

                    {accountState === 'Credit' && (
                      <Column
                        header="Settle"
                        headerClassName="text_purple"
                        alignHeader={"center"}
                        body={settlementStatusBody}
                        style={{ width: "10%" }}
                      ></Column>
                    )}

                    {(((edit_data || delete_data) && owanProject) || (clientAccountDetails?.can_edit !== null && clientAccountDetails?.can_edit === true)) && (
                      <Column
                        alignHeader="center"
                        body={tableActionBody}
                        frozen
                        alignFrozen="right"
                      ></Column>
                    )}
                  </DataTable>
                ) : (
                  <NoDataCreated
                    message={`No account details added. To add, click on Add button.`}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>


      {/* Client account modal */}
      <Dialog
        visible={showClientAccountModal}
        headerClassName="custom_modal_header"
        header={accountModalHeader}
        footer={accountModalFooter}
        dismissableMask
        closeOnEscape={false}
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseClientAccountModal}
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Add account for */}
              {dataState === 'Add' && (
                <div className="col-12">
                  <div className="page_form_group">
                    <label htmlFor="selectedAccountFor" className="custom_form_label is_required">
                      Account for
                    </label>

                    <Dropdown
                      ref={dropdownRef}
                      key={`selectedAccountFor`}
                      id="selectedAccountFor"
                      value={selectedAccountFor}
                      options={accountForList}
                      onChange={handleChangeAccountFor}
                      placeholder="Select "
                      className="form_dropdown w-100"
                      optionLabel="company_name"
                      optionValue="id"
                      filter
                      filterPlaceholder="Search here"
                      panelFooterTemplate={accountForOptionFooterTemplate}
                    />

                    {clientCompanyError && (
                      <small className="form_error_msg">
                        {clientCompanyError}
                      </small>
                    )}
                  </div>
                </div>
              )}

              {/* Date */}
              <div className="col-12">
                <DatePicker
                  key={`accountDate`}
                  id="accountDate"
                  label="Date"
                  labelHtmlFor="accountDate"
                  required={true}
                  value={accountDate}
                  placeholder="dd/mm/yyyy"
                  onChange={setAccountDate}
                  error={accountDateError}
                  showClear
                  onClear={() => setAccountDate(null)}
                />
              </div>

              {/* Order type */}
              <div className="col-12">
                <div className="page_form_group">
                  <label
                    htmlFor="cashStatus"
                    className="custom_form_label is_required"
                  >
                    Order type
                  </label>
                  <div className="response_state_area mb-3">
                    <div className="response_state">
                      <Checkbox
                        inputId="buildingMaterial"
                        name="accountAddState"
                        value={accountAddState}
                        onChange={(e) => handleChangeOrderType(e, "Cash")}
                        checked={accountAddState === "Cash"}
                      />
                      <label htmlFor="buildingMaterial">Cash</label>
                    </div>
                    <div className="response_state">
                      <Checkbox
                        inputId="clientMaterial"
                        name="cashStatus"
                        value={cashStatus}
                        onChange={(e) => handleChangeOrderType(e, "Credit")}
                        checked={accountAddState === "Credit"}
                      />
                      <label htmlFor="clientMaterial">Credit</label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Cash */}
              {accountAddState === 'Credit' && (
                <div className="col-12">
                  <div className="page_form_group">
                    <label
                      htmlFor="cashStatus"
                      className="custom_form_label is_required"
                    >
                      Cash
                    </label>
                    <div className="response_state_area mb-3">
                      <div className="response_state">
                        <Checkbox
                          inputId="buildingMaterial"
                          name="cashStatus"
                          value={cashStatus}
                          onChange={(e) => handleChangeCashStatus(e, "In")}
                          checked={cashStatus === "In"}
                        />
                        <label htmlFor="buildingMaterial">In</label>
                      </div>
                      <div className="response_state">
                        <Checkbox
                          inputId="clientMaterial"
                          name="cashStatus"
                          value={cashStatus}
                          onChange={(e) => handleChangeCashStatus(e, "Out")}
                          checked={cashStatus === "Out"}
                        />
                        <label htmlFor="clientMaterial">Out</label>
                      </div>
                    </div>

                    {cashStatusError && (
                      <small className="form_error_msg">{cashStatusError}</small>
                    )}
                  </div>
                </div>
              )}

              {/* Description */}
              <div className="col-12">
                <TextInput
                  key={`accountTitle`}
                  id="accountTitle"
                  label="Description"
                  labelHtmlFor="accountTitle"
                  required={true}
                  value={accountTitle}
                  placeholder="Enter description"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAccountTitle(e.target.value)}
                  error={accountTitleError}
                />
              </div>

              {/* Amount */}
              <div className="col-12">
                <NumberInput
                  key={`accountAmount`}
                  inputId="accountAmount"
                  label="Amount"
                  labelHtmlFor="accountAmount"
                  placeholder="Enter amount"
                  onChange={handleAccountAmountChange}
                  value={accountAmount}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={0}
                  prefix={currencySymbol + " "}
                  error={accountAmountError}
                />
              </div>

              {/* File */}
              <div className="col-12">
                <FileInput
                  key={`accountFile`}
                  id="accountFile"
                  label="Add file"
                  labelHtmlFor="accountFile"
                  required={false}
                  value={accountFileName}
                  canUploadImage={true}
                  onUpload={handleAccountFileUpload}
                  onClear={handleClearAccountFile}
                  toast={toast}
                  error={accountFileError}
                  containerClassName="mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Document view modal */}
      <DocumentViewModal
        isOpen={showDocViewModal}
        onClose={handleCloseDocViewModal}
        fileUrl={documentFileUrl}
      />
      {/*  */}


      {/* Company modal */}
      <Dialog
        visible={showCompanyModal}
        headerClassName="custom_modal_header"
        header={companyModalHeader}
        footer={companyModalFooter}
        closeOnEscape={false}
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseCompanyModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {dataState === 'Add' && (
                <div className="col-12">
                  <div className="page_form_group">
                    <Message
                      severity='info'
                      className="message_text w-100"
                      icon="bi bi-info-circle"
                      style={{ border: '1px solid', borderRadius: '8px' }}
                      text={`Add company for: ${clientAccountDetails?.job_number + ": " + clientAccountDetails?.address}`}
                    />
                  </div>
                </div>
              )}

              {/* Company */}
              {dataState === 'Add' ? (
                <div className="col-12">
                  <div className="page_form_group">
                    <label
                      htmlFor="companyName"
                      className="custom_form_label is_required"
                    >
                      Company name
                    </label>
                    <div className="input_with_button_area">
                      <InputText
                        key={`companyName`}
                        id="companyName"
                        value={companyName}
                        className="custom_form_input has_add_value"
                        placeholder="Click the Select button and find the company."
                        readOnly={true}
                        autoComplete="off"
                        onClick={handleAddClientCompany}
                      />
                      <button
                        className="add_value_btn p-ripple"
                        onClick={handleAddClientCompany}
                      >
                        {selectedClientCompany === null ? (
                          <React.Fragment>
                            <i className="bi bi-plus-lg"></i>
                            <span>Select</span>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <i className="bi bi-pencil-square"></i>
                            <span>Change</span>
                          </React.Fragment>
                        )}
                        <Ripple />
                      </button>
                    </div>

                    {companyNameError && (
                      <small className="form_error_msg">{companyNameError}</small>
                    )}
                  </div>
                </div>
              ) : (
                <div className="col-12">
                  <TextInput
                    key={`companyName`}
                    id="companyName"
                    label="Company name"
                    labelHtmlFor="companyName"
                    required={true}
                    value={companyName}
                    placeholder="Enter company name"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyName(e.target.value)}
                    error={companyNameError}
                  />
                </div>
              )}

              {/* Account name */}
              <div className="col-12">
                <TextInput
                  key={`accountName`}
                  id="accountName"
                  label="Account name"
                  labelHtmlFor="accountName"
                  required={false}
                  value={accountName}
                  placeholder="Enter account name"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAccountName(e.target.value)}
                  error={accountNameError}
                />
              </div>

              {/* Sort code */}
              <div className="col-12 col-sm-5">
                <TextInput
                  key={`sortCode`}
                  inputType="number"
                  id="sortCode"
                  label="Sort code"
                  labelHtmlFor="sortCode"
                  required={false}
                  value={sortCode}
                  placeholder="Enter 6 digits code"
                  formGroupClassName="mb-sm-2"
                  onChange={handleSortCodeChange}
                  error={sortCodeError}
                  maxLength={6}
                />
              </div>

              {/* Account number */}
              <div className="col-12 col-sm-7">
                <TextInput
                  key={`accountNumber`}
                  inputType="number"
                  id="accountNumber"
                  label="Account number"
                  labelHtmlFor="accountNumber"
                  required={false}
                  value={accountNumber}
                  placeholder="Enter account number"
                  formGroupClassName="mb-2"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAccountNumber(e.target.value)}
                  error={accountNumberError}
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Company view modal */}
      <Dialog
        visible={showCompanyViewModal}
        headerClassName="custom_modal_header"
        header={companyViewModalHeader}
        dismissableMask
        closeOnEscape={false}
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseCompanyViewModal}>
        <div className="custom_modal_body">
          <div className="p-1">
            {selectedCompany && selectedCompany !== null ? (
              <div className="row">
                <div className="col-12">
                  <div className="view_data_head_area">
                    <h4 className="view_data_head mb-0">
                      <i className="bi bi-info-circle me-2"></i>
                      Details
                    </h4>

                    {(clientAccountDetails?.shared_by == null) && (
                      <button className={`add_data_btn p-ripple`} onClick={handleEditCompany}>
                        <i className={`bi bi-pencil-square`}></i>
                        Edit
                        < Ripple />
                      </button>
                    )}
                  </div>

                  <article className={`data_view_area mb-0`}>
                    <div className="view_data_group">
                      <div className="row">
                        <div className="col-6 col-sm-5">
                          <h5 className="view_data_title">Company Name :</h5>
                        </div>
                        <div className="col-6 col-sm-7">
                          <h5 className="view_data_content text_purple text-capitalize text_bold">
                            {selectedCompany?.company_name ? selectedCompany?.company_name : '----'}
                          </h5>
                        </div>
                      </div>
                    </div>

                    <div className="view_data_group">
                      <div className="row">
                        <div className="col-6 col-sm-5">
                          <h5 className="view_data_title">Account name :</h5>
                        </div>
                        <div className="col-6 col-sm-7">
                          <h5 className="view_data_content">
                            {selectedCompany?.account_name ? selectedCompany?.account_name : '----'}
                          </h5>
                        </div>
                      </div>
                    </div>

                    <div className="view_data_group">
                      <div className="row">
                        <div className="col-6 col-sm-5">
                          <h5 className="view_data_title">Sort code :</h5>
                        </div>
                        <div className="col-6 col-sm-7">
                          <h5 className="view_data_content">
                            {selectedCompany?.sort_code ? selectedCompany?.sort_code : '----'}
                          </h5>
                        </div>
                      </div>
                    </div>

                    <div className="view_data_group">
                      <div className="row">
                        <div className="col-6 col-sm-5">
                          <h5 className="view_data_title">Account number :</h5>
                        </div>
                        <div className="col-6 col-sm-7">
                          <h5 className="view_data_content">
                            {selectedCompany?.account_no ? selectedCompany?.account_no : '----'}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            ) : (
              <div className="no_data_found mt-2 mb-2">
                <h6>
                  <i className="bi bi-exclamation-circle me-2"></i>
                  No data available for this company!
                </h6>
              </div>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Company list modal */}
      <Dialog
        visible={showCompanyListModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseCompanyListModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"companySearchKey"}
                id="companySearchKey"
                value={companySearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanySearchKey(e.target.value)}
                className="custom_form_input data_search_input"
                placeholder="Search company by name"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {companySearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setCompanySearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseCompanyListModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body has_custom_input" ref={companyListRef}>
            {filteredClientCompanyData && filteredClientCompanyData?.length > 0 ? (
              <div className="data_select_option_area">
                {filteredClientCompanyData?.map((company) => {
                  const isAlreadyAdded = companyData.some((c) => c.id === company.id);
                  return (
                    <div
                      key={company?.id}
                      className={`data_select_option p-ripple 
                        ${company?.id === selectedClientCompany?.id ? "selected" : ''}
                        ${isAlreadyAdded ? 'disabled' : ''}`}
                      onClick={() => !isAlreadyAdded ? handleSelectCompany(company) : undefined}
                    >
                      <span>{company?.company_name}</span>
                      <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                    </div>
                  )
                })}
              </div>
            ) : (
              <div className="no_records_found">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>

          <div className="page_form_group data_select_modal_footer mb-0">
            <div className="input_with_button_area">
              <InputText
                id="customCompanyName"
                value={customCompanyName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomCompanyName(e.target.value)}
                className="custom_form_input has_add_value custom_data_input"
                placeholder="Enter company name"
                autoComplete="off"
              />
              <button
                className="add_value_btn fill p-ripple"
                onClick={handleCreateCustomCompany}
                disabled={customCreateLoading || customCompanyName === ""}
              >
                {customCreateLoading ? (
                  <span>Processing</span>
                ) : (
                  <React.Fragment>
                    <i className="bi bi-plus-lg"></i>
                    <span>Add</span>
                  </React.Fragment>
                )}
                <Ripple />
              </button>
            </div>
            {customCompanyNameError && (
              <small className="form_error_msg">
                {customCompanyNameError}
              </small>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Share modal */}
      <ShareModal
        isOpen={showContactShareModal}
        canEditOption={true}
        loading={loading}
        sharedList={sharedList}
        projectContactIds={projectContactIds}
        onClose={handleCloseShareModal}
        onShare={shareDataFunction}
        title="Share Client Account"
      />
      {/*  */}


      {/* Account move modal */}
      <Dialog
        visible={showAccountMoveModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseAccountMoveModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"movingTargetSearchKey"}
                id="movingTargetSearchKey"
                value={movingTargetSearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setMovingTargetSearchKey(e.target.value);
                  setSelectedMovingTarget(null);
                }}
                className="custom_form_input data_search_input"
                placeholder="Search here"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {movingTargetSearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i className="bi bi-x-lg data_search_input_clear" onClick={() => setMovingTargetSearchKey("")}></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseAccountMoveModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body has_custom_input">
            {movingTargetList && movingTargetList?.length > 0 ? (
              <div className="data_select_option_area">
                {movingTargetList?.map((target) => (
                  <div
                    key={target?.id}
                    className={`data_select_option p-ripple ${target?.id === selectedMovingTarget?.id ? "selected" : ""}`}
                    onClick={() => handleSelecteMoveTarget(target)}
                  >
                    {target?.company_name}
                    <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="no_records_found">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>

          <div className="page_form_group data_select_modal_footer custom mb-0">
            <div>
              <h6>
                Move {selectedAccounts?.length} account{selectedAccounts?.length > 1 ? "s" : ""}:&nbsp;<br />
                <small>From: <span>{selectedCompany ? selectedCompany?.company_name : 'My account'}</span></small>&nbsp;|&nbsp;
                <small>To: <span>{selectedMovingTarget ? selectedMovingTarget?.company_name : '----'}</span></small>
              </h6>
            </div>
            <Button
              loading={accountMoveLoading}
              label={accountMoveLoading ? "Processing" : `Move (${selectedAccounts?.length})`}
              className="custom_btn primary"
              onClick={moveAccountConfirmation}
              disabled={selectedMovingTarget === null}
            />
          </div>
        </div>
      </Dialog>
      {/*  */}
    </React.Fragment>
  );
};

export default ClientAccount;
